<template lang="html">
  <v-container fluid class="pa-0"  v-scroll="onScroll">
    <div class="header-view">
      <v-layout row wrap class="pb-3">
        <v-flex xs12 sm7>
          <v-layout row wrap>
            <v-btn flat icon @click="toggleFilter= !toggleFilter">
              <i class="filter-icon pr-2"></i>
            </v-btn>
            <v-btn flat icon @click="toggleSearchCompeletions=!toggleSearchCompeletions">
              <i class="search-icon pr-4"></i>
            </v-btn>
            <input v-if="toggleSearchCompeletions"
              type="text" placeholder="search"
              class="search-input">
          </v-layout>
        </v-flex>
      </v-layout>
    </div>

    <div v-if="!loading && completions.length === 0" class="centered">
      <no-data-message>
        <v-icon slot="icon">list</v-icon>
        <template slot="message">
          There are no completions to show
        </template>
      </no-data-message>
    </div>
    <div v-else class="completion-view" v-for="(task, i) in completions">
      <v-layout row wrap class="list-elements">
        <v-flex xs12 sm4 class="pr-2 py-2">
          <router-link class="no-style-link" :to="{name: 'TaskDetails', params: {id: task.task_id }}">
            {{ task.task_name }}
          </router-link>
          </span>
        </v-flex>

        <v-flex xs12 sm5 class="py-2">
          <v-layout row wrap>
            <v-flex xs12 sm7>
              <router-link class="no-style-link" :to="{name: 'ProjectOverview', params: {id: task.project_id }}">
                <span class="sub-headers">{{ task.project_name }}</span>
              </router-link>
            </v-flex>
            <v-flex xs12 sm5>
              <span class="sub-headers">{{ getTime(task.completion_finished) }}</span>
            </v-flex>
          </v-layout>
        </v-flex>


        <v-flex xs8 sm2 class="list__link py-2">
          <div class="" @click="toUserProfile(task.user_id)" style="cursor: pointer">
            <v-list-tile-avatar style="display:inline;">
              <img v-if="getContributorAvatar(task.user_id)" :src="getContributorAvatar(task.user_id)">
              <v-avatar size="40px" v-else class="red">
                <span class="avatar-txt  white--text">{{ getInitals(task.user_id) }}</span>
              </v-avatar>
            </v-list-tile-avatar>
            <span> {{ getContributorUsername(task.user_id) }}</span>
          </div>
        </v-flex>
        <v-flex xs4 sm1 class="py-2">
          <v-layout row wrap>
            <v-btn small flat :ripple="false" class="list__link list__details-button" :to="{ name: 'TaskCompletionDetails', params: { id: task.completion_id } }">
              <span>View Details</span>
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>

    <div v-if="loading" class="loader-container">
      <loader></loader>
    </div>
  </v-container>
</template>

<script>
import moment from 'moment';
import get from 'lodash/get';
import { getOrganizerTaskCompletions } from '@/api';

import Loader from '@/components/Loader';

export default {
  components: {
    Loader,
  },
  data() {
    return {
      toggleFilter: false,
      toggleSearchCompeletions: false,
      contributors: [],

      lastScroll: 0,
      loading: false,
      completions: [],
      take: 20,
      skip: 0,
      exhausted: false,
    };
  },
  methods: {
    onScroll() {
      const scroll = this.$scrollPercent();
      const scrollingUp = this.lastScroll > scroll;
      this.lastScroll = scroll;

      if (scroll < 0.90 || scrollingUp) return null;

      this.fetchCompletionList();
      return null;
    },
    getTime(time) {
      if (!time) return '-';
      return moment(`${time}Z`).format('MMM DD, h:mm a');
    },
    toUserProfile(userId) {
      this.$router.push({ name: 'UserProfile', params: { id: userId } });
    },
    findUserById(id) {
      let user;
      for (let i = 0; i < this.contributors.length; i += 1) {
        if (this.contributors[i].user_id === id) {
          user = this.contributors[i];
          break;
        }
      }
      return user;
    },
    getContributorUsername(userId) {
      const user = this.findUserById(userId);
      return user && user.username;
    },
    getContributorAvatar(userId) {
      const user = this.findUserById(userId);
      return user && user.avatar;
    },
    getInitals(userId) {
      const username = this.getContributorUsername(userId);
      return username && username.charAt(0).toUpperCase();
    },
    fetchCompletionList: async function fetchCompletionList() {
      if (this.loading || this.exhausted) return;

      this.loading = true;
      const userToken = this.$store.getters['auth/userToken'];

      const tid = this.$route.query.effort_id;
      const pid = this.$route.query.project_id;

      try {
        const response = await getOrganizerTaskCompletions(
          userToken,
          { task_id: tid, project_id: pid, skip: this.skip, take: this.take },
        );
        this.loading = false;
        this.skip = this.skip + this.take;
        const contributors = get(response, 'data[1].data.details.contributors.details', []);
        this.contributors = [...this.contributors, ...contributors];
        const completions = get(response, 'data[1].data.details.completions', []);
        this.completions = [...this.completions, ...completions];
        this.exhausted = get(response, 'data[1].error.error_type') === 'NO_DATA';
      } catch (e) {
        this.loading = false;
      }
    },
    getCompletionType(value) {
      switch (value) {
        case 'unique':
          return 'single-grey-icon';
        case 'multi':
        default:
          return 'many-grey-icon';
      }
    },
  },
  mounted() {
    this.fetchCompletionList();
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";

.avatar-txt {
  font-size: 16px;
}

.sub-headers {
  font-size: 16px;
  color: $placeholder;
}

.completion-view:nth-child(odd) {
  background: $filter-background;
}

.header-view {
  border-bottom: 1px solid #e5e5e5;
}

.list__link {
  span {
    color: $blue;
    font-size: 13px;
  }
}

.list__details-button {
  padding-top: 6px;
}

.list-elements {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 16px;
  line-height: 2;
  padding-right: 16px;
  .btn {
    min-width: auto;
  }
}

.search-input:focus {
  outline: none;
  border-bottom: 1px solid $blue;
  width: 80%;
  font-size: 16px;
}

.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 80%;
}

.no-style-link {
  text-decoration: none;
  color: inherit;
}

.half-circle-spinner {
  height: 30px;
  width: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/CompletionList.vue